export enum CompanyColorHexes {
  DARK_MAROON = '#1A1111',
  VIVID_ORANGE = '#FF6600',
  OLIVE = '#808000',
  GREEN = '#008000',
  TEAL = '#008080',
  SOFT_INDIGO = '#666699',
  GRAY = '#808080',
  BRIGHT_ORANGE = '#FF9900',
  LIME_GREEN = '#99CC00',
  JUNGLE_GREEN = '#339966',
  AQUA = '#33CCCC',
  BRIGHT_BLUE = '#3366FF',
  MAGENTA = '#FF00FF',
  GOLDEN_YELLOW = '#FFCC00',
  SKY_BLUE = '#00CCFF',
  LIGHT_PINK = '#FF99CC',
  PEACH = '#FECB9C',
  LIGHT_YELLOW = '#FFFE9F',
  MINT = '#CCFFCC',
  PALE_CYAN = '#CCFFFF',
  SOFT_BLUE = '#99CCFF',
  LAVENDER = '#CC99FF',
  LIGHT_GRAY = '#C9C8CC',
  COOL_BLUE_GRAY = '#8490C0',
  INDIGO_GRAY = '#4C548E',
  CHARCOAL = '#262938',
  TAUPE = '#745A4D',
  SNOW_WHITE = '#F3F2F2',
  SAGE = '#85958E',
  RUST_RED = '#7C4142',
  LIGHT_OLIVE = '#D8DEC3',
  PURPLE_GRAY = '#938AAB',
  SLATE_GRAY = '#565964',
  DEEP_PURPLE = '#423C57',
  PLUM = '#665478',
  DUSTY_ROSE = '#C3AFAC',
  NAVY_BLUE = '#163148',
  DEEP_TEAL = '#176775',
  SEA_GREEN = '#148375',
  TURQUOISE = '#1D8D87',
  STEEL_BLUE = '#A2B4BF',
  LAVENDER_BLUSH = '#F3EBF9',
  ROSE_PINK = '#F172AA',
  COCOA = '#67463B',
  ROYAL_BLUE = '#4046A1',
  SKY_STEEL_BLUE = '#5292C6',
  STORMY_SEA = '#4A6C79',
  COOL_GRAY_BLUE = '#707193',
  SOFT_GREEN = '#C5DDC4',
}

export class CompanyColor {
  static readonly DARK_MAROON = new CompanyColor(CompanyColorHexes.DARK_MAROON)
  static readonly VIVID_ORANGE = new CompanyColor(CompanyColorHexes.VIVID_ORANGE)
  static readonly OLIVE = new CompanyColor(CompanyColorHexes.OLIVE)
  static readonly GREEN = new CompanyColor(CompanyColorHexes.GREEN)
  static readonly TEAL = new CompanyColor(CompanyColorHexes.TEAL)
  static readonly SOFT_INDIGO = new CompanyColor(CompanyColorHexes.SOFT_INDIGO)
  static readonly GRAY = new CompanyColor(CompanyColorHexes.GRAY)
  static readonly BRIGHT_ORANGE = new CompanyColor(CompanyColorHexes.BRIGHT_ORANGE)
  static readonly LIME_GREEN = new CompanyColor(CompanyColorHexes.LIME_GREEN)
  static readonly JUNGLE_GREEN = new CompanyColor(CompanyColorHexes.JUNGLE_GREEN)
  static readonly AQUA = new CompanyColor(CompanyColorHexes.AQUA)
  static readonly BRIGHT_BLUE = new CompanyColor(CompanyColorHexes.BRIGHT_BLUE)
  static readonly MAGENTA = new CompanyColor(CompanyColorHexes.MAGENTA)
  static readonly GOLDEN_YELLOW = new CompanyColor(CompanyColorHexes.GOLDEN_YELLOW)
  static readonly SKY_BLUE = new CompanyColor(CompanyColorHexes.SKY_BLUE)
  static readonly LIGHT_PINK = new CompanyColor(CompanyColorHexes.LIGHT_PINK)
  static readonly PEACH = new CompanyColor(CompanyColorHexes.PEACH)
  static readonly LIGHT_YELLOW = new CompanyColor(CompanyColorHexes.LIGHT_YELLOW)
  static readonly MINT = new CompanyColor(CompanyColorHexes.MINT)
  static readonly PALE_CYAN = new CompanyColor(CompanyColorHexes.PALE_CYAN)
  static readonly SOFT_BLUE = new CompanyColor(CompanyColorHexes.SOFT_BLUE)
  static readonly LAVENDER = new CompanyColor(CompanyColorHexes.LAVENDER)
  static readonly LIGHT_GRAY = new CompanyColor(CompanyColorHexes.LIGHT_GRAY)
  static readonly COOL_BLUE_GRAY = new CompanyColor(CompanyColorHexes.COOL_BLUE_GRAY)
  static readonly INDIGO_GRAY = new CompanyColor(CompanyColorHexes.INDIGO_GRAY)
  static readonly CHARCOAL = new CompanyColor(CompanyColorHexes.CHARCOAL)
  static readonly TAUPE = new CompanyColor(CompanyColorHexes.TAUPE)
  static readonly SNOW_WHITE = new CompanyColor(CompanyColorHexes.SNOW_WHITE)
  static readonly SAGE = new CompanyColor(CompanyColorHexes.SAGE)
  static readonly RUST_RED = new CompanyColor(CompanyColorHexes.RUST_RED)
  static readonly LIGHT_OLIVE = new CompanyColor(CompanyColorHexes.LIGHT_OLIVE)
  static readonly PURPLE_GRAY = new CompanyColor(CompanyColorHexes.PURPLE_GRAY)
  static readonly SLATE_GRAY = new CompanyColor(CompanyColorHexes.SLATE_GRAY)
  static readonly DEEP_PURPLE = new CompanyColor(CompanyColorHexes.DEEP_PURPLE)
  static readonly PLUM = new CompanyColor(CompanyColorHexes.PLUM)
  static readonly DUSTY_ROSE = new CompanyColor(CompanyColorHexes.DUSTY_ROSE)
  static readonly NAVY_BLUE = new CompanyColor(CompanyColorHexes.NAVY_BLUE)
  static readonly DEEP_TEAL = new CompanyColor(CompanyColorHexes.DEEP_TEAL)
  static readonly SEA_GREEN = new CompanyColor(CompanyColorHexes.SEA_GREEN)
  static readonly TURQUOISE = new CompanyColor(CompanyColorHexes.TURQUOISE)
  static readonly STEEL_BLUE = new CompanyColor(CompanyColorHexes.STEEL_BLUE)
  static readonly LAVENDER_BLUSH = new CompanyColor(CompanyColorHexes.LAVENDER_BLUSH)
  static readonly ROSE_PINK = new CompanyColor(CompanyColorHexes.ROSE_PINK)
  static readonly COCOA = new CompanyColor(CompanyColorHexes.COCOA)
  static readonly ROYAL_BLUE = new CompanyColor(CompanyColorHexes.ROYAL_BLUE)
  static readonly SKY_STEEL_BLUE = new CompanyColor(CompanyColorHexes.SKY_STEEL_BLUE)
  static readonly STORMY_SEA = new CompanyColor(CompanyColorHexes.STORMY_SEA)
  static readonly COOL_GRAY_BLUE = new CompanyColor(CompanyColorHexes.COOL_GRAY_BLUE)
  static readonly SOFT_GREEN = new CompanyColor(CompanyColorHexes.SOFT_GREEN)
  private constructor(public readonly hex: CompanyColorHexes) {}
  static all = (): CompanyColor[] => {
    return [
      CompanyColor.DARK_MAROON,
      CompanyColor.VIVID_ORANGE,
      CompanyColor.OLIVE,
      CompanyColor.GREEN,
      CompanyColor.TEAL,
      CompanyColor.SOFT_INDIGO,
      CompanyColor.GRAY,
      CompanyColor.BRIGHT_ORANGE,
      CompanyColor.LIME_GREEN,
      CompanyColor.JUNGLE_GREEN,
      CompanyColor.AQUA,
      CompanyColor.BRIGHT_BLUE,
      CompanyColor.MAGENTA,
      CompanyColor.GOLDEN_YELLOW,
      CompanyColor.SKY_BLUE,
      CompanyColor.LIGHT_PINK,
      CompanyColor.PEACH,
      CompanyColor.LIGHT_YELLOW,
      CompanyColor.MINT,
      CompanyColor.PALE_CYAN,
      CompanyColor.SOFT_BLUE,
      CompanyColor.LAVENDER,
      CompanyColor.LIGHT_GRAY,
      CompanyColor.COOL_BLUE_GRAY,
      CompanyColor.INDIGO_GRAY,
      CompanyColor.CHARCOAL,
      CompanyColor.TAUPE,
      CompanyColor.SNOW_WHITE,
      CompanyColor.SAGE,
      CompanyColor.RUST_RED,
      CompanyColor.LIGHT_OLIVE,
      CompanyColor.PURPLE_GRAY,
      CompanyColor.SLATE_GRAY,
      CompanyColor.DEEP_PURPLE,
      CompanyColor.PLUM,
      CompanyColor.DUSTY_ROSE,
      CompanyColor.NAVY_BLUE,
      CompanyColor.DEEP_TEAL,
      CompanyColor.SEA_GREEN,
      CompanyColor.TURQUOISE,
      CompanyColor.STEEL_BLUE,
      CompanyColor.LAVENDER_BLUSH,
      CompanyColor.ROSE_PINK,
      CompanyColor.COCOA,
      CompanyColor.ROYAL_BLUE,
      CompanyColor.SKY_STEEL_BLUE,
      CompanyColor.STORMY_SEA,
      CompanyColor.COOL_GRAY_BLUE,
      CompanyColor.SOFT_GREEN,
    ]
  }

  static fromHexValue = (color: string): CompanyColorHexes => {
    if (Object.values(CompanyColorHexes).includes(color as CompanyColorHexes)) {
      return color as CompanyColorHexes
    }
    return CompanyColorHexes.DARK_MAROON
  }
}
